'use client';

import { useMemo } from 'react';
import { useTabScopedDomainTree } from '../../../store/tab/domainTreeTabScopedFilterStore';
import { useTabDomainTreeFiltering } from '../../../contexts/SharedDomainTreeContext';

export function useExecutionsScope({
  endpointId,
  endpointUrl,
}: {
  endpointId: string | undefined;
  endpointUrl: string | undefined;
}) {
  const isAssetScopedView = !!endpointId || !!endpointUrl;
  const { selectedNodes } = useTabScopedDomainTree();
  const {
    endpointIds,
    urlPatterns,
    isFilterPending: isTreeFilterPending,
  } = useTabDomainTreeFiltering({
    scope: isAssetScopedView ? 'none' : 'application',
    selectedNodes,
  });
  const scopedEndpointIds = useMemo(
    () => (endpointId ? [endpointId] : endpointIds),
    [endpointId, endpointIds],
  );
  const scopedUrlPatterns = useMemo(() => {
    if (endpointId) {
      return undefined;
    }

    if (endpointUrl) {
      return [endpointUrl];
    }

    if (endpointIds && endpointIds.length > 0) {
      return undefined;
    }

    return urlPatterns && urlPatterns.length > 0 ? urlPatterns : undefined;
  }, [endpointId, endpointIds, endpointUrl, urlPatterns]);
  const scopeKey = useMemo(
    () =>
      [
        isAssetScopedView
          ? 'scoped'
          : selectedNodes.length > 0
            ? selectedNodes.join(',')
            : 'none',
        scopedEndpointIds?.join(',') ?? '',
        scopedUrlPatterns?.join(',') ?? '',
      ].join('|'),
    [isAssetScopedView, scopedEndpointIds, scopedUrlPatterns, selectedNodes],
  );

  return {
    scopedEndpointIds,
    scopedUrlPatterns,
    isTreeFilterPending,
    scopeKey,
  };
}
